export const ENV_FLAGS = [
  'IVCO_49_MOVE_IV_TO_MOBILE',
  'IT_4334_KIOSKO_MVP',
  'IT_4407_CHECK_OUT',
  'IT_4491_STRIPE_PAYMENT_FORM_V2',
  'UP_397_AIRALO_ENABLED',
] as const;
